const StatCard = ({ label, value, highlight = false }) => {
  return (
    <div
      style={{
        flex: 1,
        minWidth: 140,
        padding: "12px 24px",
        borderRadius: 12,
        background: highlight
          ? "linear-gradient(135deg, #2C6FE8 0%, #1E56C4 100%)"
          : "#FFFFFF",
        border: highlight ? "none" : "1px solid #E6E8EC",
        boxShadow: highlight ? "0 6px 16px rgba(30,86,196,0.28)" : "none",
      }}
    >
      <h6
        className={
          highlight ? "text-inverse font-medium" : "text-primary font-medium"
        }
      >
        {label}
      </h6>
      <h2
        className={
          highlight ? "text-inverse font-bold" : "text-anchor font-bold"
        }
      >
        {value}
      </h2>
    </div>
  );
};

export default StatCard;
